export function connect(schema) {
  return new WebSocket(schema);
}
